/* eslint-disable */
import React, { Component } from "react";
import cookie from "react-cookies";
import axios from "axios";
import { Link } from "react-router-dom";
import "../../common/css/owl.carousel.css";
import logo from "../../common/images/epicpay.png";
import nav from "../../common/images/navigation.svg";
import invoice from "../../common/images/invoice-icon.svg";
import vouc from "../../common/images/voucher-icon.svg";
import wallet from "../../common/images/wallet.svg";
import qrCodeDfl from "../../common/images/qr-codeDfl.png";
import { apiUrl, unquieID } from "../Settings/Config";

class Menulist extends Component {
  constructor(props) {
    super(props);

    this.state = {
      runingNum: 0,
      bottompopup: "regphone",
      showRedeemCredits: false,
      pin: "",
    };

    if (cookie.load("LoginUserId") === undefined || cookie.load("LoginUserId") === "") {
      props.history.push("/");
    }
  }

  componentDidMount() {
    this.checkCredits();
    this.loadPin();
  }
  checkCredits() {
    var urlShringTxt = apiUrl + "merchant/getSettings";
    axios
      .get(urlShringTxt, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ showRedeemCredits: res.data.result.companyRedeemType === "1" ? true : false });
        }
      })
      .catch((e) => {
        console.error("Error fetching data:", e);
      });
  }

  goToQrcdPage(event) {
    event.preventDefault();
    this.props.history.push("/companyqr");
  }
  loadPin() {
    const companyBonusType_ = cookie.load("companyBonusType") ?? '1';
    if(companyBonusType_==='4' || companyBonusType_==='5'){
    const urlShringTxt = apiUrl + "merchant/loadPin/";
    axios
      .get(urlShringTxt, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ pin: res.data.pin }, () => {
            setTimeout(() => {
              this.loadPin();
            }, 10000);
          });
        }
      })
      .catch((e) => {
        console.error("Error fetching data:", e);
      });
    }
  }

  render() {
    const companyBonusType = cookie.load("companyBonusType") ?? '1';
    return (
      <div className="main-div menu-list-page main-home-page">
        <div className="header-action header-action-mrcht">
          <div className="container">
            <div className="ha-lhs">
              <Link to="/menu">
                <img src={logo} />
              </Link>
            </div>
            <div className="ha-rhs">
              {/* <ul>
                {(companyBonusType === "4" || companyBonusType === "5") && (
                  <li className="pin-details">
                    PIN:<b>{this.state.pin}</b>
                  </li>
                )}
                <li className="navsbar">
                  {companyBonusType === "5" || companyBonusType === "4" ?(
                    <Link to="/check-in" >
                      <img src={qrCodeDfl} />
                    </Link>
                  ): (
                    <a href="#" onClick={this.goToQrcdPage.bind(this)}>
                    <img src={qrCodeDfl} />
                  </a>
                  )}
                  
                </li>
              </ul> */}
            </div>
          </div>
        </div>

        <div className="rel">
          <div className="container textcenter mrcht-menu-innner">
            <div className="callout mrcht-menu-callout">
              { (companyBonusType === "5" || companyBonusType === "4")  && (
              <ul className="checking-parent">
                <li className="pin-details">
                    PIN:<b>{this.state.pin}</b>
                  </li>
                  <li className="qr-checking">
                    <Link to="/check-in" >
                    <span>Checkin QR</span><img src={qrCodeDfl} />
                  </Link>                
                  
                </li>

              </ul>
               )}
              <div className="three-nav">
                <Link to={"/scanqrcode"} className="button rv-btn" title="Vouchers">
                  {" "}
                  <img src={vouc} /> Redeem Voucher{" "}
                </Link>
               
                {/* <Link
                  to={"/sellvoucher"}
                  className="button rv-btn"
                  title="Sell Voucher"
                >
                  {" "}
                  <img src={vouc} /> Sell Voucher{" "}
                </Link> */}

                <Link to={"/redeem"} title="Redeem Credits" className="button rc-btn">
                  {" "}
                  <img src={wallet} /> Redeem Credits{" "}
                </Link>

                <Link to={"/scan-topup-qr"} title="Redeem Credits" className="button rc-btn">
                  {" "}
                  <img src={wallet} /> Approve Bill Pay / Cash Voucher Pay{" "}
                </Link>
                <Link to={"/transactions"} title="View Daily Transactions" className="button rc-btn">
                  {" "}
                  <img src={invoice} /> View Daily Transactions{" "}
                </Link>
                <Link to={"/logout"} title="Logout" className="button rc-btn">
                  {" "}
                  Logout{" "}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Menulist;
